/**
 * THE ONE PREDICATE for the two AI mounts (see CornerMounts.jsx) — and for
 * the navbar's FroggerAI button, which used to carry a second copy of the
 * regex and would have drifted the moment this one changed.
 *
 * The facility id in `/facilities/<id>/…` OR `/my-store/<id>/…`, else null.
 *
 * Fable ruling R4 (2026-10-07, Cowork run 31): Manage Products — and the
 * rest of `/my-store/<id>/…` — is a CONSOLE page, so the FroggerAI dock
 * and its navbar button mount there and the customer FroggyAI pill stands
 * down there, through this one predicate. A my-store page declares NO
 * place (no `usePlaceSetter`), so the dock sends no `place` field from it.
 *
 * ⚠️ `decodeURIComponent` THROWS on a malformed escape — `/facilities/%`
 * is a real URL a person can type, and a `URIError` thrown during render
 * of a component mounted on EVERY route is a white screen for the whole
 * app, not a bad page. The raw segment is the honest fallback: it is what
 * the router matched, and a facility id that does not decode will not
 * resolve to a facility anyway.
 */
export const froggerDockFacilityId = (pathname) => {
  const match = /^\/(?:facilities|my-store)\/([^/]+)(?:\/|$)/.exec(pathname || '');
  if (!match) return null;
  // ⚠️ THE MARKETING CHAT IS THE ONE MY-STORE PAGE WITHOUT THE DOCK. It IS
  // an AI chat (the marketing concierge), and the S3-06.3c rule is one AI
  // chat per screen — the pill already stands down there, and a second,
  // staff chat docked beside the concierge would be the same two-chats
  // collision from the other side. Answered HERE, in the one predicate,
  // so the dock, its navbar button and the pill cannot disagree about it.
  if (/^\/my-store\/[^/]+\/marketing\/chat(?:\/|$)/i.test(pathname)) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch (err) {
    return match[1];
  }
};

export default froggerDockFacilityId;
